import React, { useEffect, useState } from "react";
import useStyles from "../../../assets/styles/styles";
import Menu from "../../Menu/Menu";
import { CircularProgress, Zoom, ClickAwayListener, Divider, FormControl, IconButton, InputLabel, TextField, Typography } from "@material-ui/core";
import {
    getDataFilterAppointment,
} from "../../../redux/actions/appointmentsActions";
import { useDispatch, useSelector } from "react-redux";
import CustomSelect from "../../../controls/Select/CustomSelect";
import NotFound from "../../HomeLogged/NotFound";
import CustomButton from "../../../controls/Button/CustomButton";
import MovementsCard from "../../Billing/Movements/MovementsCard";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { handleGoToMedicalData } from "../../../utils/utilsFunctions";
import TuneIcon from '@material-ui/icons/Tune';
import { LocalizationProvider, MobileDatePicker } from "@material-ui/lab";
import AdapterDateFns from "@material-ui/lab/AdapterDateFns";
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { format, subDays } from "date-fns";
import ModalActivities from "../../DialogActivities/ModalActivities";
import HeaderCard from "../../Billing/Movements/HeaderCard";
import { es } from "date-fns/locale";
import ControlPointOutlinedIcon from '@material-ui/icons/ControlPointOutlined';
import { getAffiliateRecipeFiles, getRecipe } from "../../../redux/actions/medicalDataAction";
import { useResizeScreen } from "../../../hooks/useResizeScreen";
import { useHistory } from "react-router-dom";





const Prescriptions = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [dateStart, setDateStart] = useState(new Date());
    const [dateEnd, setDateEnd] = useState(new Date());
    const [openPicker, setOpenPicker] = useState(false);
    const [openModalRepeatAppointment, setOpenModalRepeatAppointment] = useState(false);
    const appointments = useSelector((state) => state.appointmentsReducer);//
    const [groupFamily, setGroupFamily] = useState([]);
    const recipe = useSelector((state) => state.medicalDataReducer.recipe);
    const [loading, setLoading] = useState();
    const [selectedItem, setSelectedItem] = useState(null);
    const screenSize = useResizeScreen();
    const userCode = parseInt(window.localStorage.getItem("numeroPersona"));
    const [filterLayout, setFilterLayout] = useState('horizontal');
    const [selectedClassification, setSelectedClassification] = useState("RECETAS");
    const [selectStatusClassification, setSelectStatusClassification] = useState("INGRESADA");
    const [flag, setFlag] = useState(false);
    const recipeFiles = useSelector((state) => state.medicalDataReducer.recipeFiles);
    const history = useHistory();
    const [filtersRestored, setFiltersRestored] = useState(false);

    const persona = {
        numeroPersona: userCode,
        parametroLlamado: "FILTRO RECETAS"
    };


    const statusClassification = [
        { value: "INGRESADA", label: "INGRESADA" },
        { value: "CONSUMIDA", label: "CONSUMIDA" },
        { value: "TODOS", label: "TODOS" },
    ]


    const classificationOptions = [
        { value: "RECETAS", label: "Recetas" },
        { value: "PRESCRIPCIONES", label: "Prescripciones" },
        { value: "ORDENES", label: "Ordenes" },
    ];

    const [selectAffilliate, setSelectAffilliate] = useState({
        value: 0,
    });



    useEffect(() => {
        const updateLayout = () => {
            if (window.innerWidth <= 768) {
                setFilterLayout('vertical');
            } else {
                setFilterLayout('horizontal');
            }
        };

        window.addEventListener('resize', updateLayout);
        updateLayout();
        return () => window.removeEventListener('resize', updateLayout);
    }, []);


    useEffect(() => {
        dispatch(getDataFilterAppointment(persona));
    }, []);


    useEffect(() => {
        setLoading(false);
    }, [recipe])


    useEffect(() => {
        if (!filtersRestored) return; 
        dispatch(getRecipe({
            numeroPersona: selectAffilliate?.value,
            count: 9999,
            skip: 0,
            fechaDesde: format(dateStart, "yyyy-MM-dd"),
            fechaHasta: format(dateEnd, "yyyy-MM-dd"),
            estadoReceta: selectStatusClassification,
            clasificacionReceta: selectedClassification
        }));
        setLoading(true);
        saveFilterState();
    }, [dateStart, dateEnd, selectAffilliate?.value, selectedClassification, selectStatusClassification]);


    useEffect(() => {
        const savedFilterState = localStorage.getItem('prescriptionFilter');
    
        if (savedFilterState) {
            const parsedState = JSON.parse(savedFilterState);
            if (parsedState.dateStart) setDateStart(new Date(parsedState.dateStart + "T00:00:00"));
            if (parsedState.dateEnd) setDateEnd(new Date(parsedState.dateEnd + "T00:00:00"));
            if (parsedState.selectStatusClassification) setSelectStatusClassification(parsedState.selectStatusClassification);
            if (parsedState.selectedClassification) setSelectedClassification(parsedState.selectedClassification);
            if (parsedState.selectAffilliate) setSelectAffilliate(parsedState.selectAffilliate);
        } else {
            const today = new Date();
            const thirtyDaysAgo = subDays(today, 30);
            setDateStart(thirtyDaysAgo);
            setDateEnd(today);
        }
    
        setFiltersRestored(true);
    }, []);

    useEffect(() => {
        let listGroupFamily = appointments?.filtro?.map((val) => {
            return {
                value: parseInt(val?.numeroPersona), label: val?.apellidoNombre
            };
        });

        setGroupFamily(listGroupFamily);


    }, [appointments.filtro]);

    useEffect(() => {
        if (!filtersRestored) return; 
        if (selectAffilliate?.value) return; 

        groupFamily?.forEach((item) => {
            if (item.value == userCode) {
                setSelectAffilliate({ value: item.value, label: item.label });
            }
        });
    }, [groupFamily]);


    useEffect(() => {
        validateReduxState(recipeFiles, flag);
    }, [recipeFiles?.data?.receta]);


    function Responsive(screenSize) {
        let width = screenSize.screen.sWidth;
        if (width <= 768) return "mobile";

    }

    const searchCard = recipe?.data?.recetas?.filter((item) => {
        if (selectStatusClassification === "TODOS") {
            return true;
        } else {
            return item.recetaEstado === selectStatusClassification;
        }
    });
    

    const handleChangeSelect = () => e => {
        var nameAffilliated = groupFamily.filter((x) => x.value == e.target.value);
        setSelectAffilliate({ value: nameAffilliated[0].value, label: nameAffilliated[0].label });
    };

    const handleClickAway = () => {
        setOpenPicker(false);
    };

    const handleClick = () => {
        setOpenPicker((prev) => !prev);
    };

    const handleClickOpenDownloadModal = (item) => (e) => {
        if (item.recetaLink && item.recetaLink.trim() !== '') {
            window.open(item.recetaLink, '_blank');
        } else {
            setSelectedItem(item)
            setOpenModalRepeatAppointment(true);
        }
    };

    const handleClickdescarga = (item) => () => {

        dispatch(getAffiliateRecipeFiles({
            numeroPersona: selectAffilliate?.value,
            recetaNumero: selectedItem?.recetaNumero,
            clasificacionReceta: selectedClassification,
        }));
        setFlag(true);
        setOpenModalRepeatAppointment(false);

    };

    const handleClassificationChange = (e) => {
        setSelectedClassification(e.target.value);
    };

    const handleClassificationChangeState = (e) => {
        setSelectStatusClassification(e.target.value);
    };

    const handleClickOpenViewModal = (item) => (e) => {
        e.preventDefault();

        history.push('/PrescriptionDetail', { item });
    };

    const saveFilterState = () => {
        const filterState = {
          dateStart: dateStart ? format(dateStart, "yyyy-MM-dd") : null,
          dateEnd: dateEnd ? format(dateEnd, "yyyy-MM-dd") : null,
          selectStatusClassification,
          selectedClassification,
          selectAffilliate
        };
        localStorage.setItem('prescriptionFilter', JSON.stringify(filterState));
      };
      

    const DateRangeFilter = () => (
        <ClickAwayListener mouseEvent="onMouseDown" touchEvent="onTouchStart" onClickAway={handleClickAway}>
            <div style={{ position: "relative", margin: screen.sWidth < 768 ? '15px 13px' : '20px 30px 20px 0' }}>
                <CustomButton
                    onClick={handleClick}
                    customClass={`${classes.customHeaderBtn} ${classes.btnFilterAppointment}`}
                    icon={<TuneIcon className={classes.iconFilter} />}
                />
                {openPicker && (
                    <Zoom in={openPicker}>
                        <div className={`${classes.dropdown}`}>
                            <Typography className={`${classes.txtCardDescription} ${classes.txtEllipsis}`}>{"PERIODO"}</Typography>
                            <Divider classes={{ root: classes.dividerFilter }} />
    
                            <div className={`${classes.headerFiltro} ${classes.marginTop}`}>
                                <FormControl style={{ width: "150px", paddingTop: "10px" }} className={classes.datePicker}>
                                    <InputLabel className={`${classes.txtSubtitleCalendar} ${classes.fontSize15}`} shrink>{"DESDE"}</InputLabel>
                                    <div className={classes.top22} style={{ display: "flex", justifyContent: "space-between" }}>
                                        <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                                            <MobileDatePicker
                                                cancelText="Cancelar"
                                                toolbarTitle=""
                                                value={dateStart}
                                                onChange={(newValue) => setDateStart(newValue)}
                                                renderInput={(params) => <TextField {...params} />}
                                                format="dd/MM/YYYY"
                                            />
                                        </LocalizationProvider>
                                        <CalendarTodayIcon style={{ alignSelf: "center" }} />
                                    </div>
                                </FormControl>
    
                                <FormControl style={{ width: "150px", marginLeft: "10px", paddingTop: "10px" }} className={classes.datePicker}>
                                    <InputLabel className={`${classes.txtSubtitleCalendar} ${classes.fontSize15}`} shrink>{"HASTA"}</InputLabel>
                                    <div className={classes.top22} style={{ display: "flex", justifyContent: "space-between" }}>
                                        <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                                            <MobileDatePicker
                                                cancelText="Cancelar"
                                                toolbarTitle=""
                                                value={dateEnd}
                                                onChange={(newValue) => setDateEnd(newValue)}
                                                renderInput={(params) => <TextField {...params} />}
                                                format="dd/MM/YYYY"
                                            />
                                        </LocalizationProvider>
                                        <CalendarTodayIcon style={{ alignSelf: "center" }} />
                                    </div>
                                </FormControl>
                            </div>
                        </div>
                    </Zoom>
                )}
            </div>
        </ClickAwayListener>
    );
    


    return (
        <>
            <Menu />
            <div className={`${classes.divMyHistoryRecipe}`}>
                <>
                    <div className={`${classes.HomePrescriptionPage}`}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            {Responsive(screenSize) == "mobile" &&
                                <IconButton onClick={handleGoToMedicalData}>
                                    <ArrowBackIcon className={classes.iconFilter} />
                                </IconButton>
                            }
                            <Typography className={`${classes.titleTurn} ${classes.titleBox} ${classes.titleEmergency}`} style={{ textTransform: 'uppercase' }}>
                                ORDENES MEDICAS
                            </Typography>
                        </div>
                        <DateRangeFilter />

                    </div>
                </>
                <Divider className={`${classes.formDivider} ${classes.dividerAppointment}`} style={{ margin: "20px" }} />
                <div className={classes.boxMainLabelPrescriptionPage}>
                    <div className={classes.divAccordionPrograms} style={{ minWidth: '240px !important' }}>
                        {filterLayout === 'horizontal' ? (
                            <div style={{ display: 'flex', justifyContent: 'space-between', gap: "20px" }}>
                                <FormControl className={`${classes.formControlChronicMedicationForm} ${classes.formControlsEmergency} ${classes.formControlSelect}`} variant="standard">
                                    <CustomSelect
                                        className={`${classes.afilliateSelect}`}
                                        list={groupFamily}
                                        selected={selectAffilliate?.value}
                                        label="AFILIADO"
                                        onChange={handleChangeSelect()}
                                        style={{ marginTop: "20px" }}
                                    />
                                </FormControl>
                                <FormControl className={`${classes.formControlChronicMedicationForm} ${classes.formControlsEmergency} ${classes.formControlSelect}`} variant="standard">
                                    <CustomSelect
                                        className={`${classes.afilliateSelect}`}
                                        list={classificationOptions}
                                        selected={selectedClassification}
                                        label="TIPO"
                                        onChange={handleClassificationChange}
                                        style={{ marginTop: "20px" }}
                                    />
                                </FormControl>
                                <FormControl className={`${classes.formControlChronicMedicationForm} ${classes.formControlsEmergency} ${classes.formControlSelect}`} variant="standard">
                                    <CustomSelect
                                        className={`${classes.afilliateSelect}`}
                                        list={statusClassification}
                                        selected={selectStatusClassification}
                                        label="Estado"
                                        onChange={handleClassificationChangeState}
                                        style={{ marginTop: "20px" }}
                                    />
                                </FormControl>
                            </div>
                        ) : (
                            <>
                                <FormControl style={{ width: "350px", paddingTop: "10px", marginTop: "-10px" }}>
                                    <CustomSelect
                                        className={`${classes.afilliateSelect}`}
                                        list={groupFamily}
                                        selected={selectAffilliate?.value}
                                        label="AFILIADO"
                                        onChange={handleChangeSelect()}
                                        style={{ marginTop: "20px" }}
                                    />
                                </FormControl>
                                <FormControl style={{ width: "150px", paddingTop: "10px", marginRight: "100px" }}>
                                    <CustomSelect
                                        className={`${classes.afilliateSelect}`}
                                        list={classificationOptions}
                                        selected={selectedClassification}
                                        label="TIPO"
                                        onChange={handleClassificationChange}
                                        style={{ marginTop: "20px" }}
                                    />
                                </FormControl>
                                <FormControl style={{ width: "150px", paddingTop: "10px" }}>
                                    <CustomSelect
                                        className={`${classes.afilliateSelect}`}
                                        list={statusClassification}
                                        selected={selectStatusClassification}
                                        label="Estado"
                                        onChange={handleClassificationChangeState}
                                        style={{ marginTop: "20px" }}
                                    />
                                </FormControl>
                            </>
                        )}
                    </div>
                </div>

                <div className={`${classes.divSectionMovements}`} style={{ display: "flex", justifyContent: "center", paddingLeft: "20px", paddingRight: "20px" }}>
                    {loading ?
                        <div style={{ display: "flex", justifyContent: "center", paddingTop: '30px' }}><CircularProgress /></div>
                        : searchCard?.length > 0 ?
                            searchCard?.map((item, i) => (
                                <MovementsCard
                                    key={item?.i}
                                    count={item?.count}
                                    index={i}
                                    headerIcon={<HeaderCard  day={item?.fechaFormateada?.nombreDia} numberDay={item?.fechaFormateada?.dia} month={item?.fechaFormateada?.mes}  year={item?.fechaFormateada?.anio} />}                                    description={
                                        <div style={{ marginTop: "5px" }}>
                                            <Typography style={{ fontWeight: "500", color: '#0075c9', paddingBottom: "10px" }} className={`${classes.txtCardDescription} `}>
                                                <span>
                                                    <span> {item?.recetaClasificacion} </span>
                                                </span>
                                            </Typography>
                                            <Typography style={{ fontWeight: "500", paddingBottom: "10px" }} className={`${classes.txtCardDescription} `}>
                                                <span >MEDICO:
                                                    <span style={{ color: '#0075c9' }} > {item?.recetaMedicoNombre} </span>
                                                </span>
                                            </Typography>
                                            <Typography style={{ fontWeight: "500", paddingBottom: "10px" }} className={`${classes.txtCardDescription}`}>
                                                <span>
                                                    <span >VTO:</span>{" " +
                                                        new Date(item?.recetaFechaVigenciaHasta).toLocaleDateString('es-AR', { year: 'numeric', month: '2-digit', day: '2-digit' })}
                                                </span>
                                            </Typography>
                                            <Typography style={{ fontWeight: "500", paddingBottom: "10px" }} className={`${classes.txtCardDescription} `}>
                                                <span >ESTADO:
                                                    <span style={{ color: '#0075c9' }} > {item?.recetaEstado} </span>
                                                </span>
                                            </Typography>
                                        </div>
                                    }
                                    buttonZone={
                                        <section className="buttonZoneSection">
                                            <section className={`${classes.sectionButtons} ${classes.btnAuthorizationCard} buttonZoneContainer`}>
                                                <div className={classes.buttonZonePrescriptionPage}>
                                                    <IconButton onClick={handleClickOpenViewModal(item)} customClass={`${classes.customHeaderBtn}`}>
                                                        <Typography style={{ fontSize: '12px', fontWeight: "600", color: '#0075c9' }} className={`${classes.txtCardDescription} ${classes.txtEllipsis}`}>
                                                            VER
                                                        </Typography>
                                                        <ControlPointOutlinedIcon style={{ marginLeft: "5px", fontSize: '13px', marginTop: '-2px' }} className={classes.iconFilter} />
                                                    </IconButton>
                                                </div>
                                                <div>
                                                    {item.recetaDescargar === true  && item.recetaEstado !== "CONSUMIDA" && (
                                                        <CustomButton
                                                            title="DESCARGAR"
                                                            customClass={`${classes.lightLinearGradient} ${classes.iconButtonZonePrescriptionPage} `}
                                                            onClick={handleClickOpenDownloadModal(item)}
                                                        />
                                                    )}
                                                </div>
                                            </section>
                                        </section>
                                    }

                                />
                            ))
                            :
                            <NotFound customMsg={
                                <div className={classes.contentNotFound}>
                                    <span>No tenés historial de {selectedClassification}</span>
                                </div>}
                                wsItem={searchCard}
                                fullItem={searchCard} />
                    }
                </div>
                {
                    openModalRepeatAppointment &&
                    <ModalActivities
                        description={`¿Estás seguro que deseas descargar la ${selectedItem.recetaClasificacion?.toLowerCase()} seleccionada?`}
                        open={openModalRepeatAppointment}
                        onClose={setOpenModalRepeatAppointment}
                        modalconfirm={true}
                        modalLogout={false}
                        buttonType={'submit'}
                        handleClick={handleClickdescarga(selectedItem)}
                    />
                }
            </div>
        </>
    );
};

export default Prescriptions;






function validateReduxState(recipeFiles, flag) {
    if (recipeFiles?.data?.receta && Object.values(recipeFiles.data.receta).length > 0) {
        if (flag) {
            downloadClick(recipeFiles.data.receta[0]);
        }
    }
}

function downloadClick(item) {
    let downloadBtn = document.createElement('A');
    downloadBtn.href = "data:application/pdf;base64," + item.archivo;
    downloadBtn.download = 'receta.pdf';
    document.body.appendChild(downloadBtn);
    downloadBtn.click();
    document.body.removeChild(downloadBtn);
}
